import { makeStyles } from '@mui/styles';
import { neutral4 } from 'apollo-react/colors';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Loader from '../../components/CustomLoader';
import EditorErrorPage from '../../components/EditorErrorPage';
import Layout from '../../components/Layout';
import { SMART_INSIGHT } from '../../constants/Urls';
import ReportModelDesigner from '../../report-model-designer';
import {
  clearReportModelDesigner,
  createReportModel,
  loadDataModel,
  loadReportModel,
  setIsDesignPanelOpened,
  setReportModelReleaseType,
} from '../../report-model-designer/actions/report-model-designer.actions';
import { CUSTOM } from '../../report-model-designer/constants/report-model-designer.constants';
import {
  getReportModelName,
  hasFetchError,
} from '../../report-model-designer/selectors/report-model-designer.selectors';

const useStyles = makeStyles({
  root: {
    margin: '0 20px',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowLabel: {
    paddingTop: 8,
    paddingRight: 8,
    alignItems: 'center',
    width: '15%',
  },
  rowColumn: {
    flex: 1,
    alignItems: 'center',
    maxWidth: '50%',
  },
  radio: {
    display: 'flex',
    flexDirection: 'row',
  },
  fields: {
    marginTop: 20,
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1,
    letterSpacing: 'normal',
    color: '#000',
    marginLeft: 17,
    padding: '24px 20px 18px 5px',
  },
  loadingContainer: {
    position: 'absolute',
    width: '95%',
    height: '80%',
  },
  loaderTitle: {
    margin: 35,
    color: neutral4,
  },
});

function ReportModelPage() {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();

  const isFetchError = useSelector(hasFetchError);
  const reportModelName = useSelector(getReportModelName);

  const qsParams = qs.parse(location.search) || {};

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.title = reportModelName
      ? `SmartInsight Model Designer / ${reportModelName}`
      : 'SmartInsight Model Designer';
  }, [reportModelName]);

  useEffect(() => {
    const { reportKey, reportId, isNewReport, releaseType, isImported } = qsParams;

    const fetchData = async () => {
      setIsLoading(true);

      if (!isImported) {
        if (isNewReport) {
          dispatch(createReportModel(reportKey));
        } else {
          await dispatch(loadReportModel(reportKey, reportId));
        }
      }

      await dispatch(loadDataModel());

      dispatch(setIsDesignPanelOpened(true));

      dispatch(setReportModelReleaseType(releaseType || CUSTOM));

      setIsLoading(false);
    };

    fetchData();

    return () => {
      dispatch(clearReportModelDesigner());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout dashboardLink={SMART_INSIGHT}>
      {isFetchError ? (
        <EditorErrorPage />
      ) : isLoading ? (
        <div className={classes.loadingContainer}>
          <Loader />
        </div>
      ) : (
        <ReportModelDesigner />
      )}
    </Layout>
  );
}

export default ReportModelPage;
